import React, { FunctionComponent, ReactElement } from 'react';
import { Typography, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PageStubProps {
  text: string | ReactElement;
}

export const PageStub: FunctionComponent<PageStubProps> = ({ text }) => {
  const { t } = useTranslation();

  return (
    <Typography variant={'h5'} textAlign="center" sx={{ m: '2.5rem 1.5rem' }}>
      {text}
    </Typography>
  );
};
